import { QueryRequestProvider } from '../../component/request'
import { QueryResponseProvider } from '../../component/response'
import { ComponentRequest } from '../../component/componentLayout'
import { ListViewProvider } from '../../component/view'
import { getUserLuckyDraw } from '../api'

const comRequest = {
    type: "user_lucky_draw",

}

/**
 * LuckyDrawWrapper
 * Provides context and API for lucky draw list views.
 */
const LuckyDrawWrapper = ({ children }) => {

    /**
     * getApi
     * Fetches user lucky draw data from the API.
     */
    const getApi = (query) => {
        return getUserLuckyDraw(query)
    }
    return <ComponentRequest.Provider value={{ comRequest }}>
        <QueryRequestProvider>
            <QueryResponseProvider getApi={getApi}>
                <ListViewProvider>
                    {children}
                </ListViewProvider>
            </QueryResponseProvider>
        </QueryRequestProvider>
    </ComponentRequest.Provider>
}

export { LuckyDrawWrapper }